<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Alert History</span><br/>
      <span style="font-style: italic; font-size: 18px">history of alerts that can be filtered by date range or type, click 'Download' for a CSV with these results</span>
    </div>

    <div style="font-size: 20px; font-weight: bold; position: relative; margin: 30px" class="d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;
      Types:&nbsp;<b-form-select v-model="alert_type" :options="type_options" style="font-size: 18px; font-weight: bold; width:290px"/>
      &nbsp;&nbsp;<b-button v-on:click.prevent="load_data()">Search</b-button>
      &nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;Filter Results&nbsp;<b-form-input style="width: 200px" v-model="alert_filter" placeholder=""/>
      <span v-if="base_options && base_options.length > 2">
        &nbsp;&nbsp;|&nbsp;&nbsp;<b-form-select v-model="selected_base" :options="base_options" style="width:150px"/>
      </span>
      <span v-if="driver_confirmation_enabled">
      &nbsp;&nbsp;Confirmed:&nbsp;<b-form-select v-model="confirmed_state" :options="confirmed_options" style="font-size: 20px; font-weight: bold; width:200px"/>
      </span>&nbsp;&nbsp;
      <b-form-checkbox
        v-model="needs_attention"
        class="ml-3"
      >
        Problems Only
      </b-form-checkbox>
    </div>

    <div v-if="!loading">
      <div class="row" style="margin: 10px 10px 10px 10px; font-weight: bold; font-size: 18px;">
        <div class="col" style="border: 1px solid grey;">Total: {{summary.total_cnt}}</div>
        <div class="col" style="border: 1px solid grey;">Filtered: {{items.length}}</div>
        <div class="col" style="border: 1px solid grey;">Emails Sent: {{summary.email_cnt}}</div>
        <div class="col" style="border: 1px solid grey;">SMS Sent: {{summary.sms_cnt}}</div>
        <div class="col" style="border: 1px solid grey;">Voice Sent: {{summary.voice_cnt}}</div>
        <div v-if="summary.sms_cnt > 0" class="col-3" style="border: 1px solid grey;">SMS Sent: {{summary.sms_units}} units ({{summary.sms_units/summary.sms_cnt | roundNumber(2)}}/msg) / ${{summary.sms_cost}}</div>
        <div v-if="summary.sms_inbound_cnt > 0" class="col-2" style="border: 1px solid grey;">SMS Rcvd: {{summary.sms_inbound_cnt}} / ${{summary.sms_inbound_cost}}</div>
        <div>&nbsp;&nbsp;<b-button size="md" variant="success" @click="download">Download</b-button></div>
      </div>
    </div>

    <div class="row" style="margin:10px; font-weight: bold; font-size: 14px;">
      <template v-for="(value, key) in summary.type_unit_counts">
        <div v-if="selected_types.indexOf(key) > -1" @click="filter_by_type(key)" class="col" style="border: 2px solid red">{{key}} [{{value.count}}<span v-if="value.sms_units > (2*value.count)"> : {{value.sms_units}} units</span>]</div>
        <div v-else @click="filter_by_type(key)" class="col">{{key}} [{{value.count}}<span v-if="value.sms_units > (2*value.count)"> : {{value.sms_units}} units</span>]</div>
      </template>
    </div>

    <div>
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields"
               :current-page="currentPage" :tbody-tr-class="get_row_color"
               :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="booking_id" slot-scope="row">
          <router-link v-if="user.types[user.tenant] == 'CM'" style="font-weight: bold;" :to="{ path: '/actuals?booking_id=' + row.item.booking_hash }">{{ row.item.booking_id }}</router-link>
          <router-link v-else-if="user.types[user.tenant] == 'TBN'" style="font-weight: bold;" :to="{ path: '/actuals_tbn?booking_id=' + row.item.booking_hash }">{{ row.item.booking_id }}</router-link>
          <router-link v-else style="font-weight: bold;" :to="{ path: '/actuals_fasttrak?booking_id=' + row.item.booking_hash }">{{ row.item.booking_id }}</router-link>
        </template>

        <template slot="vehicle_id" slot-scope="row">
          <div>
            <span
              v-for="(id, idx) in (row.item.vehicle_id || '')
                .split(',')
                .map(s => s.trim())
                .filter(s => s && s.toLowerCase() !== 'none')"
              :key="id"
            >
              <router-link
                class="font-weight-bold"
                :to="{ path: '/vehicle_trip_history', query: { vehicleId: id } }"
              >{{ id }}</router-link><span
                v-if="
                  idx <
                  (
                    (row.item.vehicle_id || '')
                      .split(',')
                      .map(s => s.trim())
                      .filter(s => s && s.toLowerCase() !== 'none')
                  ).length - 1
                "
              >, </span>
            </span>
          </div>
        </template>

        <template slot="processed_time" slot-scope="row">
          {{row.item.processed_time | formatDateTimeSmall}}
          <span v-if="row.item.movement_vehicle_id.includes('reprocess')">(reprocessed)</span>
        </template>

        <template slot="confirmed_time" slot-scope="row">
          {{row.item.confirmed_time | formatDateTimeSmall}}
        </template>

        <template slot="start_datetime" slot-scope="row">
          {{row.item.start_datetime | formatDateTimeSmall}}
        </template>

        <template slot="message" slot-scope="row">
          <div v-if="row.item.voice_msg"><b>voice text:</b> {{row.item.voice_msg | trim(300)}}<hr/><b>sms text:</b></div>
          <div v-if="row.item.email_message">see details...</div>
          <div v-if="row.item.message.length < 400" style="text-align: left; font-family: monospace; white-space: normal !important;" v-html="row.item.message.replaceAll('\n','<br/>')"/>
          <div v-else @click="row.toggleDetails" style="text-align: left; font-family: monospace; white-space: normal !important;" v-html="row.item.message.substring(0,400).replaceAll('\n','<br/>') + '<br/>...'"/>
        </template>

        <template slot="email" slot-scope="row">
          <template v-if="row.item.email">
            <div style="text-align: left;"  v-for="val in row.item.email.split(',')">
              {{val}}
            </div>
          </template>
        </template>

        <template slot="sms" slot-scope="row">
          <div v-if="row.item.voice_number"><b>voice #:</b> {{row.item.voice_number}}<hr/><b>sms #:</b></div>
          <div v-if="row.item.sms" class="col" :style="row.item.sms.split(',').length > 3 ? 'overflow-y:scroll; max-height: 100px; border: 0px': 'border: 0px'">
            <div v-for="val in row.item.sms.split(',')">
              {{val}}
            </div>
          </div>
        </template>

        <template slot="provider_response" slot-scope="row">
          <div style="font-size:14px; line-height:1.4;">
            <div
              v-if="row.item.provider_response && !row.item.provider_response.includes('Message has been accepted')"
              style="font-weight:bold; color:darkred;"
            >
              sms: {{ row.item.provider_response }}
              <span v-if="row.item.phone_carrier"><br/>[{{ row.item.phone_carrier }}]</span>
            </div>

            <div
              v-else-if="row.item.sms_msg_id"
              style="font-weight:bold;"
            >
              <span style="color:green">sms: success</span>
              <span v-if="row.item.retry_attempted" style="color:darkgoldenrod">
                (retried)
              </span>
            </div>

            <div
              v-if="getLatestEmailStatus(row.item) && ['bounce','complaint'].includes(getLatestEmailStatus(row.item).status.toLowerCase())"
              style="font-weight:bold; color:darkred; margin-bottom:6px;"
            >
              <div>
                email: {{ decodeEmailStatus(getLatestEmailStatus(row.item).status) }}
              </div>
              <div><small>{{ getLatestEmailStatus(row.item).datetime | formatDateTimeSmall }}</small></div>
            </div>

            <div
              v-else-if="getLatestEmailStatus(row.item)"
              style="margin-bottom:6px;"
            >
              <div>
                <strong style="color:green">
                  email: {{ decodeEmailStatus(getLatestEmailStatus(row.item).status) }}
                </strong>
              </div>
              <div><small>{{ getLatestEmailStatus(row.item).datetime | formatDateTimeSmall }}</small></div>
            </div>
          </div>
        </template>

        <template slot="sms_drivers" slot-scope="row">
          <div v-if="row.item.sms_drivers" class="col" :style="row.item.sms_drivers.split(',').length > 3 ? 'overflow-y:scroll; max-height: 100px; border: 0px': 'border: 0px'">
            <div v-for="val in row.item.sms_drivers.split(',')">
              {{val}}
            </div>
          </div>
        </template>

        <template slot="sms_leaders" slot-scope="row">
          <div v-if="row.item.sms_leaders" class="col" :style="row.item.sms_leaders.split(',').length > 3 ? 'overflow-y:scroll; max-height: 100px; border: 0px': 'border: 0px'">
            <div v-for="val in row.item.sms_leaders.split(',')">
              {{val}}
            </div>
          </div>
        </template>

        <template slot="finish_datetime" slot-scope="row">
          {{row.item.finish_datetime | formatDateTimeSmall}}
        </template>

        <template slot="details" slot-scope="row">
          <b-button size="sm" @click="row.toggleDetails">
            {{ row.detailsShowing ? '-' : '+' }}
          </b-button>
        </template>

        <template slot="reprocess" slot-scope="row">
          <span v-if="row.item.alert_type == 'CustomerTripNotification'" size="sm" @click="reprocess_alert(row.item)"><span style="font-size: 35px;">&#8635;</span></span>
        </template>

        <template slot="row-details" slot-scope="row">
          <b-card style="text-align: left;">
            <span v-if="row.item.email">
              <b>emails:</b> {{row.item.email}}<br/>
            </span>
            <span class="recipients-list" v-if="row.item.sms_all_recipients">
              <b>SMS:</b>{{row.item.sms_all_recipients}}<br/>
            </span>
            <br/>
            <div v-if="row.item.email_message" style="text-align: left; font-family: monospace; white-space: normal !important;" v-html="row.item.email_message"/>

            <div v-if="row.item.message.indexOf('<html') != -1" style="text-align: left; font-family: monospace; white-space: normal !important;" v-html="row.item.message"/>
            <div v-else style='min-width: 2100px; display: flex; flex-wrap: wrap'>
              <pre>{{row.item.message}}</pre>
            </div>
            <div v-if="row.item.prev_message">
              <b>previous message:</b><br/>
              <pre style='min-width: 2100px; display: flex; flex-wrap: wrap'>{{row.item.prev_message}}</pre>
            </div>
          </b-card>
        </template>
      </b-table>
      <b-row>
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import {api_url, get_alerts, reprocess_alerts_for_booking} from '../networking/apis'
import {mapState} from "vuex";
import moment from 'moment'
import {justDate} from "@/helpers/dates";
import axios from 'axios';

export default {
  name: 'alert_list',
  components: {
  },

  data() {
    return {
      msg: 'alerts',
      alert_filter: '',
      needs_attention: false,
      sms_stats_enabled: true,
      driver_confirmation_enabled: true,
      items: [],
      items_full: [],
      summary: [],
      base_options: [],
      selected_base: '',
      loading: true,
      details_fromDate: justDate(moment().add(-1, 'days')),
      details_toDate: justDate(moment()),
      alert_type: '',
      selected_types: [],
      confirmed_state:'',
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pages: [],
      type_options: [
        { value: '', text: 'All Types' },
        { value: 'LateAlert', text: 'Late Alerts' },
        { value: 'DriverTripNotification', text: 'Driver Trip Notifications' },
        { value: 'CustomerTripNotification', text: 'Customer Trip Notifications' },
        { value: 'CustomerPostTripNotification', text: 'Customer Post Trip Notifications' },
        { value: 'PassengerTripNotification', text: 'Passenger Trip Notifications' },
        { value: 'MissingDVIR', text: 'Missing DVIR Alert' },
        { value: 'MissingDriverConfirmations', text: 'Missing Driver Confirmations' },
        { value: 'PostTripNotification', text: 'Post Trip Notifications' },
        { value: 'VehicleActivityAlert', text: 'Vehicle Activity Alert' },
        { value: 'VehicleInactivityAlert', text: 'Vehicle Inactivity Alert' },
        { value: 'RelayNotification', text: 'Relay Notifications' },
        { value: 'DriverHOSAlert', text: 'HOS Duration Alert' },
        { value: 'UnplannedVehicleActivityAlert', text: 'Unplanned Vehicle Activity' },
        { value: 'CustomerSurvey', text: 'Customer Survey' },
        { value: 'GroupMessage', text: 'Group Message' },
        { value: 'VehicleStatusReceived', text: 'Vehicle Status' },
        { value: 'EmailReceived', text: 'Email Received' },
        { value: 'SMSReceived', text: 'SMS Received' },
        { value: 'SMSResponse', text: 'SMS Response' },
      ],
      confirmed_options: [
        { value: '', text: 'All' },
        { value: 'unconfirmed', text: 'Unconfirmed' },
        { value: 'confirmed', text: 'Confirmed' },
      ],
      fields_all: [],
      fields: [
        { key: 'details', label: '', sortable: false, thStyle: { width: "20px" }},
        //{ key: 'booking_hash', label: 'Booking Ref', sortable: true, thStyle: { width: "110px" }},
        { key: 'booking_id', label: 'Booking ID', sortable: true, thStyle: { width: "110px" }},
        { key: 'vehicle_id', label: 'Vehicle', sortable: true, thStyle: { width: "110px" }},
        { key: 'start_base', label: 'Base', sortable: true, thStyle: { width: "110px" }},
        { key: 'alert_type', label: 'Alert Type', sortable: true, thStyle: { width: "120px" }},
        { key: 'processed_time', label:'Alert Time', sortable: true, thStyle: { width: "110px" }},
        { key: 'provider_response', label:'Delivery Status', sortable: true, thStyle: { width: "120px" }},
        { key: 'confirmed_time', label:'Conf Time', sortable: true, thStyle: { width: "110px" }},
        // { key: 'sms_recipients', label:'SMS #', sortable: true, thStyle: { width: "110px" }},
        // { key: 'sms_size', label:'SMS Size', sortable: true},
        // { key: 'sms_units', label:'SMS Units', sortable: true},
        { key: 'sms_name', label:'Recipient', sortable: true, thStyle: { width: "110px" }},
        { key: 'sms_drivers', label:'Driver #', sortable: true, thStyle: { width: "120px" }},
        { key: 'sms_leaders', label:'Customer #', sortable: true, thStyle: { width: "120px" }},
        { key: 'sms', label:'Other #', sortable: true, thStyle: { width: "120px" }},
        { key: 'email', label: 'Email Recipients', sortable: true, thStyle: { width: "120px" }},
        { key: 'message', label: 'Message', sortable: true, thStyle: { width: "400px" }},
        { key: 'reprocess', label: '', sortable: false, thStyle: { width: "20px" }},
      ]
      ,
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(360, 'days'),
        maxDate: moment(),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      },

    }
  },

  async created() {
    this.fields_all = this.fields
    this.check_features()
  },
  methods: {
    async check_features() {
      this.check_cols()
      this.load_data()
    },
    filter_by_type(type) {
      let idx = this.selected_types.indexOf(type)
      if (idx > -1) {
        this.selected_types.splice(idx, 1);
      } else {
        this.selected_types.push(type)
      }
    },
    async check_cols() {
      this.sms_stats_enabled = this.user.role == 'admin'
      this.driver_confirmation_enabled = this.user.features[this.user.tenant].driver_trip_notifications_confirmation_enabled
      this.relay_notifications_enabled = this.user.features[this.user.tenant].relay_notifications_enabled
      this.driver_surveys_enabled = this.user.features[this.user.tenant].driver_surveys_enabled
      this.group_message_sender_enabled = this.user.features[this.user.tenant].group_message_sender_enabled
      this.fields = this.fields_all
      if (!this.driver_confirmation_enabled)
        this.fields = this.fields.filter(item => item.key != 'confirmed_time')

      if (!this.sms_stats_enabled)
        this.fields = this.fields.filter(item => (item.key != 'booking_hash' && item.key != 'sms_size' && item.key != 'sms_recipients' && item.key != 'sms_units'))

      if (this.alert_type && (this.alert_type == 'SMSReceived' || this.alert_type == 'SMSResponse'))
        this.fields = this.fields.filter(item => (item.key != 'booking_id' && item.key != 'booking_hash' && item.key != 'vehicle_id' && item.key != 'sms_drivers' && item.key != 'sms_leaders'))
      else if (this.alert_type && (this.alert_type == 'GroupMessage'))
        this.fields = this.fields.filter(item => (item.key != 'booking_id' && item.key != 'booking_hash' && item.key != 'vehicle_id' && item.key != 'sms_drivers' && item.key != 'sms_leaders' && item.key != 'sms_name'))
      else if (this.alert_type && (this.alert_type == 'DriverHOSAlert'))
        this.fields = this.fields.filter(item => (item.key != 'booking_id' && item.key != 'booking_hash' && item.key != 'vehicle_id' && item.key != 'sms_leaders'))
    },
    async load_data() {
      this.loading = true
      try {
        const {value: { data = [] } } = await get_alerts(this.user.tenant, this.alert_type, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.alerts
        this.items_full = data.alerts
        this.base_options = data.summary.bases
        // this.type_options = data.summary.alert_types
        this.filter_results()
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.loading = false
    },
    async reprocess_alert(item) {
      if (confirm("Are you sure you want to reprocess and resend notifications for this alert?")) {
        reprocess_alerts_for_booking(this.user.tenant, item.alert_type, item.booking_hash)
        this.$emit('showAlert', 'reprocessing alert', 'info', 5000)
      }
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info', 5000)
      axios.defaults.headers.common.Accept = {}
      axios.post(
          `${api_url}bookings/alerts/download`,
          {
            tenant: this.user.tenant,
            start_date: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            end_date: moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            alert_type: this.alert_type,
            alert_filter: this.alert_filter,
            start_base: this.selected_base
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
            'download',
            `alerts-${this.user.tenant}-${this.details_fromDate}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'alert data could not be downloaded.', 'danger')
      })
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
      this.details_toDate = moment(this.details_toDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    get_row_color(item, type) {
      if (!item || type !== 'row') return
      return item.status
    },
    filter_results() {
      this.items = this.items_full
      if (this.selected_types.length > 0)
        this.items = this.items.filter(item => (this.selected_types.indexOf(item.alert_type) != -1))
      if (this.alert_type != '')
        this.items = this.items.filter(item => (this.contains(item.alert_type,this.alert_type)))
      if (this.confirmed_state != '')
        if (this.confirmed_state != 'confirmed')
          this.items = this.items.filter(item => (item.confirmed_time == null))
        else if (this.confirmed_state != 'unconfirmed')
          this.items = this.items.filter(item => (item.confirmed_time != null))
      if (this.alert_filter != '') {
        const val = this.alert_filter
        this.items = this.items.filter(item => (this.contains(item.provider_response, val) || this.contains(item.message, val) || this.contains(item.start_base, val) || this.contains(item.booking_id, val) || this.contains(item.email, val) || this.contains(item.sms_leaders, val) || this.contains(item.sms_drivers, val) || this.contains(item.sms, val) || this.contains(item.sms_name, val) || this.contains(item.vehicle_id, val)))
      }
      if (this.selected_base) {
        this.items = this.items.filter(item => this.contains(item.start_base,this.selected_base))
      }
      if (this.needs_attention) {
        this.items = this.items.filter(item => {
          const emailStatus = this.getLatestEmailStatus(item);
          const hasEmailIssue =
            emailStatus &&
            ['bounce','complaint'].includes(emailStatus.status.toLowerCase());
          const hasSmsIssue =
            item.provider_response &&
            !item.provider_response.includes('Message has been accepted');
          return hasEmailIssue || hasSmsIssue;
        });
      }
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    },

    getLatestEmailStatus(item) {
      if (!item.email_msg_status || !item.email_msg_status.length) return null;
      return item.email_msg_status.reduce((a, b) =>
        new Date(a.datetime) > new Date(b.datetime) ? a : b
      );
    },

    decodeEmailStatus(rawStatus) {
      if (!rawStatus) return ''
      const map = {
        send:      'sent',
        delivery:  'delivered',
        bounce:    'bounced',
        complaint: 'filed complaint',
        open:      'opened',
        click:     'clicked link',
      }
      return map[rawStatus.toLowerCase()] || rawStatus
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    alert_type(target_from_date) {
      this.check_cols()
      this.filter_results();
    },
    confirmed_state(target_from_date) {
      this.filter_results()
    },
    alert_filter() {
      this.filter_results()
    },
    needs_attention() {
      this.filter_results();
    },
    selected_base() {
      this.filter_results()
    },
    selected_types() {
      this.filter_results()
    },
    details_fromDate(target_from_date) {
      this.details_fromDate = target_from_date
      if (moment(this.details_fromDate, 'MM-DD-YYYY') > moment(this.details_toDate, 'MM-DD-YYYY'))
        this.details_toDate = this.details_fromDate
    }
  }
}
</script>

<style>
.error { background-color: rgba(255,0,0,0.25)}
.success { background-color: hsla(120,100%,75%,0.3)}
.unprocessed { background-color: hsla(200,40%,80%,0.3) }
.cancelled { background-color: hsla(290,60%,70%,0.3) }

.error td { background-color: rgba(255,0,0,0.25)}
.success td {background-color: hsla(120,100%,75%,0.3)}
.unprocessed td { background-color: hsla(200,40%,80%,0.3) }
.cancelled td { background-color: hsla(290,60%,70%,0.3) }


div.row:nth-child(even) {
  background-color: #f2f2f2;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.header {
  font-weight: bold;
}

div.col {
  border: 1px solid grey;
}

.table td {
  padding: .1rem !important;
}

.mvmt-table td {
  vertical-align: middle !important;
}

div.wrap {
  border: 1px solid grey;
  flex-wrap: wrap;
  display: flex;
  inline-size: 150px;
  /* overflow-wrap: break-word; */
}

recipients-list {
  white-space: break-spaces !important;
}

</style>

